import React, { useState, useContext } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import colors from "../../config/colors";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import UserContext from "../../context/UserContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import NtModalInputField from "../../components/NtModalInputField";
import Logger from "../../common/utils/Logger";
import { parseError } from "@ntconnect/framework/pbx";
import NtTabController from "../../components/NtTabController";
import NtModalError from "../../components/NtModalError";
import NtModalAccountPickerField from "./NtModalAccountPickerField";
import { createHardwareFile } from "../../api/hardware";
import hardwareaccountsdata from "../data/hardwareaccountsdata";
import hardwaretimezonedata from "../data/hardwaretimezonedata";
import NtHardwareTimezonePicker from "./NtHardwareTimezonePicker";
import NtHardwareRingtonePicker from "./NtHardwareRingtonePicker";
import hardwareringtonedata from "../data/hardwareringtonedata";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";

function NtHardwareNewForm({ onCancel, onCreate }) {
  const [mac, setMac] = useState("");
  const [extension1, setExtension1] = useState("");
  const [extension2, setExtension2] = useState("");
  const [proxy1, setProxy1] = useState("");
  const [proxy2, setProxy2] = useState("");
  const [port1, setPort1] = useState("5060");
  const [port2, setPort2] = useState("5060");
  const [ringtone1, setRingtone1] = useState(
    hardwareringtonedata[hardwareringtonedata?.length - 1],
  );
  const [ringtone2, setRingtone2] = useState(
    hardwareringtonedata[hardwareringtonedata?.length - 1],
  );
  const [timezone, setTimezone] = useState(hardwaretimezonedata[0]);
  const [account, setAccount] = useState(hardwareaccountsdata[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const context = useContext(UserContext);

  const isRequiredFields = () => {
    return (
      mac &&
      ((extension1 && proxy1 && port1) || (extension2 && proxy2 && port2))
    );
  };

  const handleCreate = async () => {
    setLoading(true);

    setError(null);

    let params = {
      mac: mac,
      timezone: timezone?.id,
      domain: context.user?.domain,
    };

    if (extension1 && proxy1 && port1) {
      params.account1 = {
        extension: extension1?.item?.extension,
        password: extension1?.item?.password,
        proxy: proxy1,
        port: port1,
        ringtone: ringtone1?.id,
        name:
          extension1?.item?.effective_caller_id_name ||
          extension1?.item?.extension.substring(4),
      };
    }

    if (extension2 && proxy2 && port2) {
      params.account2 = {
        extension: extension2?.item?.extension,
        password: extension2?.item?.password,
        proxy: proxy2,
        port: port2,
        ringtone: ringtone2?.id,
        name:
          extension2?.item?.effective_caller_id_name ||
          extension2?.item?.extension.substring(4),
      };
    }

    const response = await createHardwareFile(params);

    Logger("Hardware Create", response);

    if (response.ok) {
      if (onCreate) {
        onCreate();
      }
    } else {
      setError(parseError(response));
    }

    setLoading(false);
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>Add new Device</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 6 }]}>
        Add new Hardware Configuration for IP Grandstream Phone
      </NtModalSubtitle>

      <NtTabController
        containerStyle={{ marginTop: 20 }}
        options={hardwareaccountsdata}
        selection={account}
        onPress={(item) => {
          setAccount(item);
        }}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 25 }}
        title={"Mac *"}
        placeholder={"Mac *"}
        value={mac}
        setValue={(text) => setMac(text)}
      />

      <NtModalAccountPickerField
        containerStyle={{ marginTop: 25 }}
        title={"Extension *"}
        placeholder={"Extension *"}
        value={account?.id == "1" ? extension1 : extension2}
        removeOptions={["ringgroup", "recording", "voicemail", "other"]}
        setValue={account?.id == "1" ? setExtension1 : setExtension2}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 25 }}
        title={"Proxy *"}
        placeholder={"Proxy *"}
        value={account?.id == "1" ? proxy1 : proxy2}
        setValue={account?.id == "1" ? setProxy1 : setProxy2}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 25 }}
        title={"Port *"}
        placeholder={"Port *"}
        value={account?.id == "1" ? port1 : port2}
        setValue={account?.id == "1" ? setPort1 : setPort2}
      />

      <NtHardwareRingtonePicker
        containerStyle={{ marginTop: 20 }}
        selection={account?.id == "1" ? ringtone1 : ringtone2}
        onPress={account?.id == "1" ? setRingtone1 : setRingtone2}
      />

      <NtHardwareTimezonePicker
        containerStyle={{ marginTop: 20 }}
        selection={timezone}
        onPress={(item) => setTimezone(item)}
      />

      <NtModalError error={error} containerStyle={{ marginTop: 6 }} />

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        {loading && (
          <NtActivityIndicator
            color={colors.blue}
            size="small"
            containerStyle={{ marginRight: 25 }}
          />
        )}

        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />

        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={"Create"}
          onPress={() => {
            if (isRequiredFields()) {
              handleCreate();
            }
          }}
          enabled={isRequiredFields()}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
  fieldTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: colors.darker,
  },
});

export default NtHardwareNewForm;
